import { createSlice } from "@reduxjs/toolkit";

const chatSlice = createSlice({
    name: "chats",
    initialState: [],
    reducers: {
        addChat: (state, action) => {
            const newChat = {
                // id: Math.random(),
                from: action.payload.from,
                msg: JSON.stringify(action.payload.msg),
                component_name: action.payload.component_name,
                meta: action.payload.meta,
                // date: Date.now(),
            };
            state.push(newChat);
        },
        clearShowInfoCard: (state) => {
            // find last system message and clear its meta.showInfoCard
            for (let i = state.length - 1; i >= 0; i--) {
                if (state[i]?.from === 'system' && state[i]?.meta && state[i].meta.showInfoCard) {
                    state[i].meta = { ...(state[i].meta || {}), showInfoCard: false };
                    break;
                }
            }
        },
        reset: (state) => {
            state.length = 0;
        },
    },
});
export const { addChat, clearShowInfoCard, clearChat, reset} = chatSlice.actions;
export default chatSlice.reducer;